import logo from "./logo.svg";
import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import Navbar from "./components/Navbar";
import Chat from "./components/Chat";
import Imaging from "./components/Imaging";
import Home from "./components/Home";
import SuggesticAI from "./components/SuggesticAI";
import ChatScreen from "./components/ChatScreen";
import MealPlannerScreen from "./components/MealPlanner/MealPlannerScreen";
import RecipeCard from "./components/MealPlanner/RecipeCard";
import MealPlan from "./components/MealPlanner/MealPlan";
import MealPlannerV2 from "./components/MealPlannerV2";
import MealPlannerCopilot from "./components/MealPlannerCopilot/MealPlannerCopilot";
import CountryStateSelector from "./components/CountryStateSelector";
import AnomalyDetection from "./components/MealPlanner/AnomalyDetection";
import MindfulEating from "./components/MindfulEating/MindfulEating";
import FitnessForm from "./components/FitnessPlanner/FitnessPlannerScreen";
import GenerateReportScreen from "./components/BiWeeklyReport/GenerateReportScreen";
import {
  UserReportList,
  UserReportDetail,
} from "./components/BiWeeklyReport/GenerateReportScreen";
import BiWeeklyGuide from "./components/BiWeeklyGuide/BiWeeklyGuide";
import WeekOneReview from "./components/WeekOneReport/WeekOneReview";

function AppContent() {
  const location = useLocation();
  const isReportDetailPage = /^\/user\/[^/]+\/reports\/?$/.test(location.pathname) || /^\/first-report\//.test(location.pathname);

  return (
    <>
      {!isReportDetailPage && <Navbar />}
      <Routes>
        <Route path="/" Component={Home}></Route>
        <Route path="/chat" Component={ChatScreen} />
        <Route path="/imaging" Component={Imaging} />
        <Route exact path="/fitnessplanner-ai" Component={FitnessForm} />
        <Route exact path="/mealplanner-ai" Component={MealPlannerCopilot} />
        <Route exact path="/anomaly-ai" Component={AnomalyDetection} />
        {/* <Route exact path="/mindful-eating" Component={MindfulEating} /> */}
        <Route exact path="/biweekly-reports" Component={UserReportList} />
        <Route path="/user/:userId/reports" Component={UserReportDetail} />
        <Route exact path="/biweekly-reports-guide" Component={BiWeeklyGuide} />
        <Route path="/first-report/:reportId" Component={WeekOneReview} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
